export const UI_UPDATE_QUERY_KEY = 'preika-ui'

export function normalizeBuildId (value) {
  return String(value || '').trim()
}

export function createVersionAssetUrl (href, timestamp = Date.now()) {
  const url = new URL('./version.json', href)
  url.searchParams.set('_', String(timestamp))
  return url.toString()
}

export function createVersionedReloadUrl (href, buildId, routeFullPath) {
  const url = new URL(href)
  const normalizedBuildId = normalizeBuildId(buildId)

  if (normalizedBuildId) {
    url.searchParams.set(UI_UPDATE_QUERY_KEY, normalizedBuildId)
  }

  if (routeFullPath) {
    const route = String(routeFullPath)
    if (route.charAt(0) === '#') {
      url.hash = route
    } else {
      url.hash = '#' + (route.charAt(0) === '/' ? route : '/' + route)
    }
  }

  return url.toString()
}

export function evaluateBuildObservation ({
  currentBuildId,
  candidateBuildId,
  candidateFirstSeenAt,
  observedBuildId,
  now,
  stabilityMs,
  alreadyConfirmed
}) {
  const current = normalizeBuildId(currentBuildId)
  const candidate = normalizeBuildId(candidateBuildId)
  const observed = normalizeBuildId(observedBuildId)

  if (!observed || observed === current) return 'current'
  if (alreadyConfirmed) return 'confirm'
  if (candidate !== observed) return 'candidate'
  if (Number(now) - Number(candidateFirstSeenAt) < Number(stabilityMs)) return 'wait'
  return 'confirm'
}

export function shouldReloadAutomatically ({
  dirty,
  activeRequests,
  visibilityState,
  idleForMs,
  idleThresholdMs
}) {
  if (dirty || Number(activeRequests) > 0) return false
  if (visibilityState === 'hidden') return true
  return Number(idleForMs) >= Number(idleThresholdMs)
}

export function isChunkLoadError (error) {
  const message = error && error.message
    ? String(error.message)
    : String(error || '')

  return /ChunkLoadError|Loading (?:CSS )?chunk [^ ]+ failed|Failed to fetch dynamically imported module/i.test(message)
}

/**
 * 送った本文をサーバが扱えなかった応答かどうか。
 *
 * 画面が古いままだと、旧い項目名で送って解釈されないことがある。
 * そのときは版を確認しに行きたい。定期確認は5分間隔なので、
 * それを待たずにこの合図で確かめる。
 *
 * ただし本文が読めない原因は画面の古さだけではない。サーバ側の
 * 不具合でも起きる（実際に起きた）。だからサーバは「画面が古い」とは
 * 断定せず、何が読めなかったかだけを返す。ここで版を確認しに行っても、
 * 版が同じなら何も起きないので、確認そのものは無害。
 *
 * STALE_CLIENT は旧バックエンドが返していたコード。段階配置の間だけ
 * 見ておき、全環境が新しくなったら外す。
 */
const UNREADABLE_BODY_CODES = [
  'REQUEST_BODY_UNREADABLE',
  'REQUEST_BODY_TYPE_MISMATCH',
  'UNSUPPORTED_MEDIA_TYPE',
  'STALE_CLIENT'
]

export function isBodyContractErrorResponse (error) {
  const data = error && error.response ? error.response.data : null
  if (!data) return false
  return UNREADABLE_BODY_CODES.indexOf(data.code) >= 0
}
